const divEquipServCard = {
  service: 'Servicio',
  label: 'Revisado por:',
  place: 'Lugar',
  company: 'Empresa',
};

export default divEquipServCard;
